import { render, staticRenderFns } from "./table_user.vue?vue&type=template&id=b06c1bca&scoped=true"
import script from "./table_user.vue?vue&type=script&lang=js"
export * from "./table_user.vue?vue&type=script&lang=js"
import style0 from "./table_user.vue?vue&type=style&index=0&id=b06c1bca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06c1bca",
  null
  
)

export default component.exports